/* eslint-disable react/display-name */
import React, { ReactNode } from 'react';

interface ModalProps {
  children: ReactNode;
  isOpen: boolean;
  className?: string;
  onDismiss: (arg?: any) => unknown;
  showClose?: boolean;
}

const Modal = ({
  isOpen,
  onDismiss,
  showClose = true,
  children,
  className,
}: ModalProps): JSX.Element => {
  // Handler for close Modal
  const closeModal: (e: React.MouseEvent<HTMLButtonElement>) => void = (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => {
    e.stopPropagation();
    onDismiss();
  };

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {isOpen ? (
        <div className="absolute w-full h-full inset-0 z-50 flex flex-col justify-end rounded-0 bg-black-normal bg-opacity-70 d:items-end">
          <div
            className={`${
              // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
              isOpen ? 'animate-slide-in' : 'animate-slide-out'
            } d:w-70 d:right-0 d:relative rounded-t-xl absolute left-0 bottom-0 w-full max-w-screen-md bg-white-normal shadow-md transform pt-8 pb-7 px-6 ${className}`}
          >
            {/* Show Cross button only if showClose is true */}
            {showClose ? (
              <button
                data-testid="close-modal"
                onClick={closeModal}
                className="absolute top-4 right-4 text-3xl  justify-end"
              >
                &times;
              </button>
            ) : (
              ''
            )}
            {/* Modal Body will go here */}
            {children}
          </div>
        </div>
      ) : null}
    </>
  );
};

Modal.Body = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}): JSX.Element => {
  // Add any specific styles for the modal body here
  return <div className={`${className ? className : ''} d:flex d:justify-center`}>{children}</div>;
};

export default Modal;
